import React from 'react';
import { Box, List, ListItem, Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { getHeaderInfo } from '../../../../lib/helper/RoomStructureHelper';
import { RoomSectionHeaderProps } from './types';
import SectionHeader from '../../../SectionHeader/SectionHeader';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.spacing(1),
  },
  listItem: {
    padding: theme.spacing(2, 2.75),
    textTransform: 'none',
  },
}));

const RoomHeadersList: React.FC<RoomSectionHeaderProps> = (
  props: RoomSectionHeaderProps
): JSX.Element => {
  const classes = useStyles();

  const { onClick, structureHeaders } = props;

  return (
    <Box className={classes.container}>
      <List disablePadding>
        {structureHeaders.map((header) => {
          const { id } = header;
          const [name, icon, logo] = getHeaderInfo(header);

          return (
            <ListItem
              button
              classes={{ root: classes.listItem }}
              key={`header-${id}`}
              onClick={() => onClick(header)}
            >
              <SectionHeader
                disableAvatar={!icon && !logo}
                icon={icon}
                logo={logo}
                name={name}
                variant="body2"
              />
            </ListItem>
          );
        })}
      </List>
    </Box>
  );
};

export default RoomHeadersList;
